import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import paypalLogo from '#src/assets/paypal.svg';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';

const PayPalLogo = styled.img`
  display: flex;
  height: var(--triple-unit);
  width: 40px;
  background-color: var(--c-nd-900);
  padding: 2px;
  border-radius: var(--half-unit);
  object-fit: contain;
  object-position: center;
`;

const Root = styled(Horizontal)`
  &.column {
    flex-direction: column;
    gap: var(--half-unit);
  }
`;

const Baseline = styled(Horizontal)`
  align-items: baseline;
`;

export const Paypal = ({
  column,
  children,
}: {
  column?: boolean;
  children?: ReactNode;
}) => {
  return (
    <Root className={classNames({ column })}>
      <PayPalLogo src={paypalLogo} alt="PayPal" />
      <Baseline>
        <BodyM color="var(--c-white)">PayPal</BodyM>
        {children}
      </Baseline>
    </Root>
  );
};
